import { faVolume, faStop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSound from 'use-sound';
import React, { useEffect } from 'react';
import './Step.module.scss';
import { motion } from 'framer-motion';

type StepProps = {
    step: number;
    type: string;
};

export default function Step({ type, step }: StepProps) {
    const [play, { stop, isPlaying, sound }] = useSound(
        `/audio/spiekbrief/${type}/${step}.mp3`
    );

    useEffect(() => () => stop(), [sound?._src]);

    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            styleName="step"
            onClick={() => (isPlaying ? stop() : play())}
        >
            <div styleName="left">
                <p>{step}</p>
                <FontAwesomeIcon icon={isPlaying ? faStop : faVolume} />
            </div>
            <div styleName="right">
                <img
                    src={`/images/step-menu/${type}-${step}.svg`}
                    alt="step"
                    style={{
                        transform: `translateY(${
                            step === 2 && type === 'A'
                                ? 3
                                : step === 4 && type === 'A'
                                ? 5
                                : step === 4 && type === 'B'
                                ? -1
                                : 6
                        }px) scale(${step === 4 && type === 'B' ? 1.1 : 1})`,
                    }}
                />
            </div>
        </motion.div>
    );
}
